export const XING_3_FLAG = 'enable_vision_type';
